class FeatureTabs extends HTMLElement {
  constructor() {
    super();
    this.activateOnHover = this.dataset.activateOnHover !== 'false';
    this.headings = this.querySelectorAll('.feature-tabs__heading');
    this.items = this.querySelectorAll('.feature-tabs__item');
    this.panels = this.querySelectorAll('.feature-tabs__panel');
    this.mediaItems = this.querySelectorAll('.feature-tabs__media-item');
    this.navButtons = this.querySelectorAll('.feature-tabs__nav');
    this.count = this.headings.length;
    this.activeIndex = 0;
    this.desktopMq = window.matchMedia('(min-width: 990px)');

    this.onClick = this.onClick.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onNavClick = this.onNavClick.bind(this);
    this.onMqChange = this.onMqChange.bind(this);
  }

  connectedCallback() {
    this.headings.forEach((btn) => {
      btn.addEventListener('click', this.onClick);
      btn.addEventListener('mouseenter', this.onMouseEnter);
      btn.addEventListener('keydown', this.onKeydown);
    });
    this.navButtons.forEach((btn) => btn.addEventListener('click', this.onNavClick));
    this.desktopMq.addEventListener('change', this.onMqChange);
    this.setActive(0, false);
  }

  disconnectedCallback() {
    this.headings.forEach((btn) => {
      btn.removeEventListener('click', this.onClick);
      btn.removeEventListener('mouseenter', this.onMouseEnter);
      btn.removeEventListener('keydown', this.onKeydown);
    });
    this.navButtons.forEach((btn) => btn.removeEventListener('click', this.onNavClick));
    this.desktopMq.removeEventListener('change', this.onMqChange);
  }

  onClick(event) {
    const idx = parseInt(event.currentTarget.dataset.index, 10);
    if (this.desktopMq.matches) {
      this.setActive(idx);
    } else if (this.activeIndex === idx) {
      this.setActive(-1);
    } else {
      this.setActive(idx);
    }
  }

  onMouseEnter(event) {
    if (!this.desktopMq.matches || !this.activateOnHover) return;
    const idx = parseInt(event.currentTarget.dataset.index, 10);
    this.setActive(idx);
  }

  onKeydown(event) {
    if (this.count <= 1) return;

    let nextIdx = null;
    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      nextIdx = (this.activeIndex + 1 + this.count) % this.count;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      nextIdx = (this.activeIndex - 1 + this.count) % this.count;
    } else if (event.key === 'Home') {
      nextIdx = 0;
    } else if (event.key === 'End') {
      nextIdx = this.count - 1;
    }

    if (nextIdx !== null) {
      event.preventDefault();
      this.setActive(nextIdx);
      this.headings[nextIdx].focus();
    }
  }

  onNavClick(event) {
    const direction = event.currentTarget.dataset.direction;
    const delta = direction === 'next' ? 1 : -1;
    const next = (this.activeIndex + delta + this.count) % this.count;
    this.setActive(next);
  }

  onMqChange() {
    if (this.desktopMq.matches && this.activeIndex < 0) {
      this.setActive(0);
    }
  }

  setActive(index) {
    this.activeIndex = index;

    this.items.forEach((el, i) => {
      el.classList.toggle('is-active', i === index);
    });

    this.headings.forEach((el, i) => {
      el.setAttribute('aria-expanded', i === index ? 'true' : 'false');
    });

    this.panels.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      const link = el.querySelector('a');
      if (link) link.setAttribute('tabindex', active ? '0' : '-1');
    });

    this.mediaItems.forEach((el, i) => {
      const active = i === index;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
  }
}

if (!customElements.get('feature-tabs')) {
  customElements.define('feature-tabs', FeatureTabs);
}
